import { emptyValue } from "./Utils";


export function saveSf(taskId:number, inputId:number, input:HTMLElement){
    let answer = $(input).val();
    answer = (answer != null) ? parseInt(answer.toString()) : emptyValue;

    return {answer: answer};
}